<template>
    <v-system-bar app height="36px" class="justify-center darktext--text font-weight-bold" color="anchor20opacity" :class="mobile() ? 'text-caption' : 'text-body-2'">
        {{ $tc('trialExpirationBanner', trialExpirationDays, { numberDays: trialExpirationDays }) }}
    </v-system-bar>
</template>
<script>
import { repeatedMethodsMixin } from '../mixins/repeatedMethodsMixin'
export default {
    mixins: [repeatedMethodsMixin],
    computed:{
      productPlan() {
          return this.$store.state.productPlan
      },
      trialExpirationDays(){
          let date_1 = new Date(this.productPlan.trial_ends_at);
          let date_2 = new Date();

          let difference = date_1.getTime() - date_2.getTime();
          let totalDays = Math.ceil(difference / (1000 * 3600 * 24));

          return totalDays
      }
    }
}
</script>

